import { RootState } from '../types'

export const getToastSelector = (state: RootState) => state.toasts
